import { render } from "./PopupMessage.vue?vue&type=template&id=7c045978&scoped=true"
import script from "./PopupMessage.vue?vue&type=script&lang=js"
export * from "./PopupMessage.vue?vue&type=script&lang=js"

import "./PopupMessage.vue?vue&type=style&index=0&id=7c045978&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c045978"]])

export default __exports__